import React, {Component} from "react"

import tracking from "@irati-tracking/admin"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import Tabs from "@irati/ui/src/Tabs"
import authentication from "@irati/auth"
import {Card} from "@irati/ui/src/Layout"
import {Body} from "@irati/ui/src/Typography"
import mainTheme from "@irati/ui/src/global/theme"

import TopCelebrated from "../../../components/Reporting/Celebrations/TopCelebrated"
import RewardTransactions from "../../../components/Reporting/RewardTransactions"

interface Props extends InjectIntl {}

class Individuals extends Component<Props> {

  componentDidMount = () => {
    tracking.analyticsPeople()
  }

  render() {
    const {formatMessage} = this.props

    return authentication.apps("recognition") ?
      <Tabs
        addMarginTop
        mountOnEnter
        unmountOnExit
        tabs={[
          {
            title: formatMessage({id: "admin.reporting.celebrations.people.title"}),
            key: "celebratedPeople",
            component: <TopCelebrated />
          },
          {
            title: formatMessage({id: "admin.reporting.celebrations.teams.title"}),
            key: "celebratedTeams",
            component: <TopCelebrated isTeams />
          },
          {
            title: formatMessage({id: "admin.reporting.transactions.title"}),
            key: "rewardTransactions",
            component: <RewardTransactions isTeams />
          }
        ]} />
      : <>
        <Card marginBottom={4} bgColor={mainTheme.colors.greys.lightest}>
          <Body>
            <FormattedMessage id="admin.reporting.turnOnCelebration" />
          </Body>
        </Card>
        <RewardTransactions isTeams />
      </>
  }
}

export default injectIntl(Individuals)
